import * as cnsts from './AutocodeConstants';

// may be temporary... needed to build expression list similar to smartsearch
const AutocodeExpressionListGenerator = () => {
  const addparenItem = (isOpen, expressionItems) => {
    expressionItems.push({
      node: '',
      recType: ' ',
      keyword: isOpen ? '(' : ')',
      shortText: isOpen ? '(' : ')',
      shortTextCatgView: isOpen ? '(' : ')',
      objectType: 'operator',
    });
  };

  const addOperatorItem = (node, expressionItems) => {
    expressionItems.push({
      node: '',
      recType: ' ',
      keyword: node.data.type.label,
      shortText: node.data.type.label,
      shortTextCatgView: node.data.type.label,
      objectType: 'operator',
    });
  };

  const addDictionaryItem = (node, partsToShow, expressionItems) => {
    const d = new Date();
    if (node.data) {
      expressionItems.push({
        title: node.toLabelString(partsToShow),
        expression: node.toExpressionString(),
        lastModified: `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`,
        keyword: node.toExpressionString(),
        textPath: node.data.textPath,
        modeled: node.data.modeled,
        uniqueId: node.data.uniqueId,
        midpoint: node.data.midpoint,
        node: node.data.node,
        pathId: node.data.path,
        rectype: node.data.rectype,
        shortText: node.data.shortText,
        shortTextCatgView: node.data.shortTextCatgView,
        breadcrumbs: node.data.breadcrumbs,
        objectType: 'operand',
        recordType: node.data.rectype,
      });
    }
  };

  const addDefinitionItem = (node, expressionItems) => {
    const shortTextCatgView = node.data.title;
    expressionItems.push({
      ...node.data,
      shortTextCatgView,
      objectType: 'operand',
      keyword: node.data.keyword ? node.data.keyword : node.data.expression,
    });
  };

  const addFunctionItems = () => {
    // I don't think we need this function
    // look in AutocodeLabelsGenerator.jsx
  };

  const buildOperatorItem = (node, partsToShow, expressionItems) => {
    const genOutput = node => {
      if (node.type === cnsts.AC_NODETYPE_OPERATOR) {
        genOutput(node.children[0]);
        addOperatorItem(node, expressionItems);
        genOutput(node.children[1]);
      } else if (node.type === cnsts.AC_NODETYPE_DEFINITION) {
        addparenItem(true, expressionItems);
        addDefinitionItem(node, expressionItems);
        addparenItem(false, expressionItems);
      } else if (node.type === cnsts.AC_NODETYPE_FUNC) {
        addFunctionItems(node, expressionItems);
      } else {
        addparenItem(true, expressionItems);
        addDictionaryItem(node, partsToShow, expressionItems);
        addparenItem(false, expressionItems);
      }
    };

    addparenItem(true, expressionItems);
    genOutput(node);
    addparenItem(false, expressionItems);
  };

  const buildObjectsAddedArray = (node, partsToShow) => {
    const expressionItems = [];
    switch (node.type) {
      default:
        break;
      case cnsts.AC_NODETYPE_OPERATOR: {
        buildOperatorItem(node, partsToShow, expressionItems);
        break;
      }
      case cnsts.AC_NODETYPE_DATAPOINT: {
        addDictionaryItem(node, partsToShow, expressionItems);
        break;
      }
      case cnsts.AC_NODETYPE_DEFINITION: {
        addDefinitionItem(node, expressionItems);
        break;
      }
      case cnsts.AC_NODETYPE_FUNC: {
        addFunctionItems(node, expressionItems);
        break;
      }
    }
    return expressionItems;
  };
  return { buildObjectsAddedArray };
};

export default AutocodeExpressionListGenerator;
